
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 67.169 69.731"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M57.367 59.706c-5.792 0-10.137-4.901-10.137-11.919 0-2.228.78-5.458 1.671-8.243.78-2.562 1.559-5.235 1.559-7.018 0-4.122-2.228-6.238-6.684-6.238l-1.448.111v37.094h3.899v6.238H0v-6.238h3.899V0h38.43v21.499c9.803 0 13.144 4.456 13.144 11.251-.111 1.337-.668 3.787-1.671 7.352-1.114 3.676-1.671 6.238-1.671 7.797 0 4.122 2.228 7.018 4.79 7.018 3.23 0 5.347-4.344 5.347-10.916v-20.72l-3.676-3.787v-8.132L52.02 4.121 56.03.445l11.139 12.253v31.301c0 6.349-1.114 10.471-3.342 12.587-2.115 2.118-4.343 3.12-6.46 3.12zM33.975 24.395V8.466H12.476v15.929h21.499zm-5.793 18.937c0-2.116-4.344-9.691-4.901-9.691L20.83 37.54c-1.671 2.785-2.451 4.79-2.451 5.792 0 2.785 2.116 5.013 4.901 5.013 2.675-.001 4.902-2.228 4.902-5.013z","fill":"currentColor"}})])
          )
        }
      }
    